angular.module('dpw.directives')
    .directive('dpwFeatureImage', [function () {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                attrs.$observe('ngSrc', function() {
                    var image = new Image();
                    image.onload = function () {
                        var self = this;
                        scope.$apply(function () {
                            scope.isLoaded = true;
                            (self.width / self.height > 1) && (scope.isLandscape = true);
                        });
                        image = null;
                    };
                    image.onerror = function () {
                        image = null;
                    };
                    image.src = attrs.ngSrc;
                });
            }
        };
    }]);